import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { DataRoomShareableLink } from 'models/ShareableLink';
import { getIsArrayEmpty } from 'utils';
import WarningExclamationIcon from 'icons/WarningExclamation.icon';
import ResolvePopup from 'components/ResolvePopup';
import Tag from 'components/ListingPortfolioCard/components/Tag';
import { COLOR_VARIANT } from 'models/Colors';

import './ShareableLinkName.styles.scss';

type ShareableLinkNameProps = {
  className?: string;
  link: DataRoomShareableLink;
};

const ShareableLinkName: React.FC<ShareableLinkNameProps> = (props) => {
  const { className, link } = props;

  const { name, fileIds } = link;

  const isEmpty = getIsArrayEmpty(fileIds);

  const classes = classNames(
    'shareable-link-name',
    { 'shareable-link-name--empty': isEmpty },
    className,
  );

  const { t } = useTranslation();

  return (
    <div className={classes}>
      {isEmpty && (
        <ResolvePopup onHover popupContent={t('noFilesInSecureLink')}>
          <WarningExclamationIcon />
        </ResolvePopup>
      )}

      <span className="name">{name}</span>

      {isEmpty && <Tag variant={COLOR_VARIANT.YELLOW} content={t('noFiles')} />}
    </div>
  );
};

export default ShareableLinkName;
